import ControlCenterProvider from 'FF/Vue/ControlCenter/Core/ControlCenterProvider';

const Providers: {} = {
    ControlCenterProvider
};

export default Providers;